module.exports = __webpack_public_path__ + "fontawesome-webfont.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-awesome/fontawesome-webfont.ttf?v=4.7.0
// module id = ../../../../../src/assets/fonts/font-awesome/fontawesome-webfont.ttf?v=4.7.0
// module chunks = 40